var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "install-pc" }, [
    _c("div", { staticClass: "figure" }),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "install-title" }, [
        _vm._v(_vm._s(_vm.$t("welfare_title_install_pc"))),
      ]),
      _c("div", { staticClass: "install-subtitle" }, [
        _vm._v(_vm._s(_vm.$t("welfare_subtitle_install_pc"))),
      ]),
      _c("div", { staticClass: "gift-code-txt" }, [
        _vm._v(_vm._s(_vm.$t("welfare_pc_gift_key"))),
      ]),
      _c(
        "div",
        {
          staticClass: "gift-code",
          on: {
            click: function ($event) {
              return _vm.doCopy("PLAYSOSONPC")
            },
          },
        },
        [
          _vm._v(" " + _vm._s(_vm.$t("welfare_pc_gift_code")) + " "),
          _c("div", { staticClass: "copy-btn" }),
        ]
      ),
      _c("div", { staticClass: "rule" }, [
        _vm._v(_vm._s(_vm.$t("welfare_pc_gift_code_rule"))),
      ]),
      _c("div", { staticClass: "award" }),
      _c("div", { staticClass: "btn", on: { click: _vm.installPc } }, [
        _c("div", { staticClass: "icon" }),
        _vm._m(0),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "txt" }, [
      _c("div", { staticClass: "t" }, [_vm._v("PLAY ON PC")]),
      _c("div", { staticClass: "b" }, [_vm._v("ONLY FOR WINDOWS")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }